import AbstractAxiosService from './AbstractAxiosService'
import { config } from '@/config'

export default class ContaoService extends AbstractAxiosService {
  constructor (options = {}) {
    super(options)
  }

	orderVouchers({ vouchers, firstname, lastname, company, street, postcode, city, details, countryCode, phoneNumber, email, message, checkAgb, holidayVouchers, asGift, giftMessage, contentId, brand = config.BRAND, lang = config.LANGUAGE, locale = config.LOCALE }) {
		return this.makeRequest('post', '/api/vouchers/buy', { vouchers, firstname, lastname, company, street, postcode, city, details, countryCode, phoneNumber, email, message, holidayVouchers, asGift, giftMessage, checkAgb, contentId, brand }, { params: { lang, locale } });
	}

	checkVoucherBalance({ cardNumber, lang = config.LANGUAGE, locale = config.LOCALE }) {
		return this.makeRequest('post', '/api/vouchers/balance', { cardNumber }, { params: { lang, locale } });
	}

	reloadVoucher({ cardNumber, cvc, value, lang = config.LANGUAGE, locale = config.LOCALE }) {
		return this.makeRequest('post', '/api/vouchers/reload', { cardNumber, cvc, value }, { params: { lang, locale } });
	}

	// COURSE
	courseRegistration({ form, lang = config.LANGUAGE, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest('post', '/api/course/register', form, { params: { lang, locale }, group: accumulatorGroup })
	}
}
